import gql from 'graphql-tag';

export const meshSetMutation = gql`
  mutation ($input: MeshSetInput) {
    meshSet(input: $input)
    {
      jobId
      jobArn
    }
  }
`
